module.exports = __webpack_public_path__ + "img/muted.ebc0d47.svg";